<template>
<div>

    <p>Detail the plan and tier options below with the <b>total monthly cost</b>.</p>

    <table class="table pt-4">
        <tbody>
        <tr>
            <th>Tier</th>
            <th>Enabled</th>
            <th>Total Cost</th>
            <th>Employee Cost</th>
            <th>Employer Cost</th>
        </tr>

        <tr>
            <td>Single</td>
            <td><form-input label="" type="checkbox" :disabled="true" :model-value="true" :form-check-inline="true" /></td>
            <td><form-input label="" v-model="formData.single_total_cost" :errors="errors.single_total_cost" type="currency" /></td>
            <td><form-input label="" :disabled="true" :model-value="employeeCosts.single" type="currency" /></td>
            <td><form-input label="" :disabled="true" :model-value="employerCosts.single" type="currency" /></td>
        </tr>

        <tr>
            <td>Single + 1</td>
            <td><form-input label="" v-model="formData.has_single_plus_one" type="checkbox" :form-check-inline="true" @update:modelValue="toggleTier('single_plus_one')" /></td>
            <td><form-input label="" v-model="formData.single_plus_one_total_cost" :errors="errors.single_plus_one_total_cost" type="currency" :disabled="!formData.has_single_plus_one" /></td>
            <td><form-input label="" :disabled="true" :model-value="employeeCosts.single_plus_one" type="currency" /></td>
            <td><form-input label="" :disabled="true" :model-value="employerCosts.single_plus_one" type="currency" /></td>
        </tr>

        <tr>
            <td>Single + children</td>
            <td><form-input label="" v-model="formData.has_single_plus_children" type="checkbox" :form-check-inline="true" @update:modelValue="toggleTier('single_plus_children')" /></td>
            <td><form-input label="" v-model="formData.single_plus_children_total_cost" :errors="errors.single_plus_children_total_cost" type="currency" :disabled="!formData.has_single_plus_children" /></td>
            <td><form-input label="" :disabled="true" :model-value="employeeCosts.single_plus_children" type="currency" /></td>
            <td><form-input label="" :disabled="true" :model-value="employerCosts.single_plus_children" type="currency" /></td>
        </tr>

        <tr>
            <td>Family</td>
            <td><form-input label="" v-model="formData.has_family" type="checkbox" :form-check-inline="true" @update:modelValue="toggleTier('family')" /></td>
            <td><form-input label="" v-model="formData.family_total_cost" :errors="errors.family_total_cost" type="currency" :disabled="!formData.has_family" /></td>
            <td><form-input label="" :disabled="true" :model-value="employeeCosts.family" type="currency" /></td>
            <td><form-input label="" :disabled="true" :model-value="employerCosts.family" type="currency" /></td>
        </tr>
        </tbody>
    </table>
</div>
</template>

<script>
import moment from 'moment'
import FormMixin from '@/mixins/Form'

function formatAsCurrency(val) {
    val = ('' + val).trim()

    val = (1 * val).toFixed(2)
    if (val.split('.').length < 2) {
        val = val + '.00'
    }
    if (val.split('.')[1].length < 2) {
        val = val + '0'
    }
    if (val[0] == '.') {
        val = '0' + val
    }
    return val
}


export default {
    props: ['initialValue', 'employeeCostCovered', 'dependentCostCovered'],
    mixins: [FormMixin],
    computed: {
        tiers() {
            return [
                'single',
                'single_plus_one',
                'single_plus_children',
                'family',
            ]
        },
        singleEmployerCost() {
            return formatAsCurrency(this.formData.single_total_cost ? (this.formData.single_total_cost * this.employeeCostCovered / 100) : '')
        },
        employerCosts() {
            const result = {}
            this.tiers.forEach(t => {
                if (t == 'single') {
                    result[t] = this.singleEmployerCost
                }
                else {
                    const totalCost = this.formData[t + '_total_cost']
                    if (totalCost && this.formData.single_total_cost) {
                        let dependentEmployerCost = (totalCost - this.formData.single_total_cost) * this.dependentCostCovered / 100
                        dependentEmployerCost = Math.max(0, dependentEmployerCost)

                        let employerCost = 1 * dependentEmployerCost + 1 * this.singleEmployerCost
                        employerCost = Math.min(1 * this.singleEmployerCost, employerCost)
                        employerCost = Math.min(totalCost, employerCost)


                        result[t] = formatAsCurrency(employerCost)
                    }
                    else {
                        result[t] = '0.00'
                    }

                }
            })
            return result
        },
        employeeCosts() {

            const result = {}
            this.tiers.forEach(t => {
                let employeeCost = this.formData[t + '_total_cost'] ? (this.formData[t + '_total_cost'] - this.employerCosts[t]) : ''
                if (employeeCost) {
                    employeeCost = Math.max(0, employeeCost)
                }

                result[t] = formatAsCurrency(employeeCost)
            })
            return result
        },
    },
    data() {
        return {
            formData: this.makeFormData(),
            formRules: {
                single_total_cost: {presence: {allowEmpty: false}, },
            },
            errors: {},
        }
    },
    methods: {
        getFormRules() {
            const rules = JSON.parse(JSON.stringify(this.formRules))
            if (this.formData.has_single_plus_one) {
                rules.single_plus_one_total_cost = {presence: {allowEmpty: false}, }
            }

            if (this.formData.has_single_plus_children) {
                rules.single_plus_children_total_cost = {presence: {allowEmpty: false}, }
            }

            if (this.formData.has_family) {
                rules.family_total_cost = {presence: {allowEmpty: false}, }
            }

            return rules
        },
        makeFormData() {
            return {
                single_total_cost: this.initialValue.single_total_cost ? this.initialValue.single_total_cost : '',

                single_plus_one_total_cost: this.initialValue.single_plus_one_total_cost ? this.initialValue.single_plus_one_total_cost : '',
                single_plus_children_total_cost: this.initialValue.single_plus_children_total_cost ? this.initialValue.single_plus_children_total_cost : '',
                family_total_cost: this.initialValue.family_total_cost ? this.initialValue.family_total_cost : '',

                has_single_plus_one: this.initialValue.has_single_plus_one ? true : false,
                has_single_plus_children: this.initialValue.has_single_plus_children ? true : false,
                has_family: this.initialValue.has_family ? true : false,

            }
        },
        toggleTier(tier) {
            if (this.formData['has_' + tier]) {
                this.formData[tier + '_total_cost'] = ''
            }
            else {
                this.formData[tier + '_total_cost'] = '0.00'
            }
        },
    },
}
</script>
